import { FlexRow } from '@/components/common/Flex';
import { Paragraph, Text, Title } from '@/components/common/Typography';
import { Box, BoxProps } from '@chakra-ui/react';
import { PlentyGoalAccountFinancialEntity } from '@common/financialEntities';
import styleguide from '@common/styleguide';
import { toPct } from '@common/util/styles';
import { BarChart02, Shield01 } from '../common/icons';
import { riskLabelByRiskScore } from './helpers';

interface RiskPortfolioSliderProps extends BoxProps {
    goalAccount: PlentyGoalAccountFinancialEntity;
}

export default function RiskPortfolioSlider({
    goalAccount,
    ...props
}: RiskPortfolioSliderProps) {
    const riskScore = goalAccount.info.riskScore;
    const riskScoreMax = 10;
    const pct = (riskScore / riskScoreMax) * 100;
    const riskLabel = riskLabelByRiskScore[riskScore].toLowerCase();

    return (
        <Box {...props}>
            <Paragraph mb={6} lineHeight={1}>
                <Title fontWeight="medium" as="span">
                    {riskScore}
                </Title>{' '}
                <Text as="span" mr={3}>
                    / {riskScoreMax}
                </Text>{' '}
                {riskLabel}
            </Paragraph>
            <FlexRow alignItems="center">
                <Shield01 size="sm" color="textMuted" />
                <Box
                    mx={2}
                    flexGrow={1}
                    bg="gray.200"
                    borderRadius="full"
                    h={1.5}
                    pos="relative"
                    overflow="hidden"
                >
                    <Box
                        pos="absolute"
                        left={0}
                        top={0}
                        w={toPct(pct)}
                        h="full"
                        bg={styleguide.colors.blue}
                        borderRadius="full"
                    />
                </Box>
                <BarChart02 size="sm" color="textMuted" />
            </FlexRow>
        </Box>
    );
}
